(function () {
  const FREE_SHIPPING_THRESHOLD = 17500; // €175 in centen

  function formatHeldMoney(cents) {
    const euros = cents / 100;
    const hasDecimals = euros % 1 !== 0;

    return '€' + new Intl.NumberFormat('nl-BE', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    }).format(euros);
  }

  function renderHeldCart(cart) {
    if (!cart) return;

    const total = cart.total_price;

    // Verzendboodschap
    document
      .querySelectorAll('[data-held-shipping-message]')
      .forEach(function (el) {
        const message =
          total >= FREE_SHIPPING_THRESHOLD
            ? '✓ Gratis verzending'
            : 'Verzending €6 · Gratis vanaf €175';
            /*const message =
          total >= FREE_SHIPPING_THRESHOLD
            ? 'Gratis verzending - Week van de Belgische Mode'
            : 'Gratis verzending - Week van de Belgische Mode';*/
        if (el.textContent.trim() !== message) {
          el.textContent = message;
        }
      });
  }

  async function syncHeldCart() {
    try {
      const root =
        window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root
          : '/';

      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Cart ophalen mislukt');
      }

      const cart = await response.json();

      renderHeldCart(cart);
    } catch (error) {
      console.error('HELD cart update:', error);
    }
  }

  // Bij normale cart/quantity update
  document.addEventListener('cart:updated', function () {
    setTimeout(syncHeldCart, 50);
  });

  // Wanneer een nieuw product via AJAX is toegevoegd
  document.addEventListener('ajaxProduct:added', function () {
    // Impulse krijgt even tijd om de drawer opnieuw te renderen
    setTimeout(syncHeldCart, 100);
    setTimeout(syncHeldCart, 400);
  });

  // Eerste paginalaad
  document.addEventListener('DOMContentLoaded', function () {
    syncHeldCart();
  });
})();